export default __webpack_public_path__ + "static/media/F.d84169c9.svg";